import React, { useState, useEffect } from 'react'
import { motion } from 'motion/react'
import type { FieldValues } from '../../fieldTypes'
import { twColorToHex } from '../../../utils/twColor'

export function SuccessCheckmark({ values = {} }: { values?: FieldValues }) {
  const [key, setKey] = useState(0)
  const circleDuration = values.circleDuration ?? 0.6
  const checkDelay = values.checkDelay ?? 0.5
  const stiffness = values.stiffness ?? 200
  const damping = values.damping ?? 15
  const color = twColorToHex(values.color ?? 'bg-green-500')
  const strokeWidth = values.strokeWidth ?? 3

  useEffect(() => {
    const interval = setInterval(() => setKey((k) => k + 1), 3000)
    return () => clearInterval(interval)
  }, [])

  return (
    <div className="flex items-center justify-center h-full">
      <motion.svg
        key={key}
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
      >
        <motion.circle
          cx="32"
          cy="32"
          r="28"
          stroke={color}
          strokeWidth={strokeWidth}
          fill="none"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: circleDuration, ease: 'easeOut' }}
        />
        <motion.path
          d="M20 33 L28 41 L44 25"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 0.4, delay: checkDelay, type: 'spring', stiffness, damping }}
        />
      </motion.svg>
    </div>
  )
}
